import { ArticleCardSkeleton } from "@/ui/components/data-display";
import { Column, Grid } from "@/ui/components/layout";
import { FC } from "react";
import { TArticleFeedCardsSkeletonProps } from "../ArticleFeed.config";

export const ArticleFeedCardsSkeleton: FC<TArticleFeedCardsSkeletonProps> = (
  { cardCount },
) => (
  <Grid data-component="ArticleFeedCardsSkeleton" tag="ul">
    { Array.from({ length: cardCount }).map((_, index) => (
      <Column
        tag="li"
        key={index}
        spans={{ xl: "6" }}
      >
        <ArticleCardSkeleton />
      </Column>
    )) }
  </Grid>
);
